import React, { createContext, useContext, useState, useEffect } from 'react';

interface SoundContextType {
  soundEnabled: boolean;
  setSoundEnabled: (enabled: boolean) => void;
}

const SoundContext = createContext<SoundContextType | undefined>(undefined);

export function SoundProvider({ children }: { children: React.ReactNode }) {
  const [soundEnabled, setSoundEnabled] = useState<boolean>(() => {
    // Load from localStorage
    try {
      const stored = localStorage.getItem('sound-enabled');
      const enabled = stored !== null ? JSON.parse(stored) : true; // Default: enabled
      return enabled;
    } catch (e) {
      console.error('[SoundProvider] Error reading localStorage:', e);
      return true;
    }
  });

  useEffect(() => {
    // Save to localStorage
    localStorage.setItem('sound-enabled', JSON.stringify(soundEnabled));
  }, [soundEnabled]);

  return (
    <SoundContext.Provider value={{ soundEnabled, setSoundEnabled }}>
      {children}
    </SoundContext.Provider>
  );
}

export function useSoundEnabled() {
  const context = useContext(SoundContext);
  if (!context) {
    throw new Error('useSoundEnabled must be used within SoundProvider');
  }
  return context;
}
